import ecologicalUnitApi from '@/api/ecological-unit.api'

export const ecologicalUnitService = (function () {
  'use strict'

  /**
   * Devuelve una lista de UE con nombre, para seleccionarlas al dar de alta UM
   * @param {*} enterpriseId 
   */
  async function findForSelector(enterpriseId, farmId) {
    try {
      const response = await ecologicalUnitApi.findForSelector(enterpriseId, farmId)
      return response.data
    } catch (exception) {
      console.log(exception)
      return []
    }
  }

  /**
   * Devuelve los datos para la tabla del ABM de Grupos
   * @param {*} pageSize
   * @param {*} pageNumber
   * @param {*} headers
   * @param {*} enterpriseIds
   */
  async function findAll(pageSize, pageNumber, headers = false, enterpriseIds) {
    try {
      const response = await ecologicalUnitApi.findAll(pageSize, pageNumber, headers, enterpriseIds)
      return response.data
    } catch (exception) {
      console.log(exception)
      return {
        data: [],
        headers: []
      }
    }
  }

  /**
   * Devuelve el total de grupos de la collection para el paginador de la tabla del ABM
   */
  async function getTotal(enterpriseIds) {
    try {
      const response = await ecologicalUnitApi.getTotal(enterpriseIds)
      return response.data
    } catch (exception) {
      console.log(exception)
      return 0
    }
  }

  /**
   * Para validar el nombre
   * Devuelve true si ya está asignado a un grupo
   * @param {*} name
   * @param {*} enterpriseId
   * @param {*} farmId
   */
  async function validateEcologicalUnitName(name, enterpriseId, farmId) {
    try {
      if (name) {
        const response = await ecologicalUnitApi.validateEcologicalUnitName(name, enterpriseId, farmId)
        return response.data
      } else {
        return false
      }
    } catch (exception) {
      console.log(exception)
      return false
    }
  }

  /**
   * Para eliminar un ecologicalUnit
   */
  async function deleteOne(enterpriseId, farmId, idEcologicalUnit) {
    await ecologicalUnitApi.deleteOne(enterpriseId, farmId, idEcologicalUnit)
  }

  /**
   * Para eliminación múltiple
   */
  async function deleteMany(deletes) {
    await ecologicalUnitApi.deleteMany(deletes)
  }


  /**
   * Crea una nuevo grupo en la collection
   * @param {*} ecologicalUnit
   */
  async function create(ecologicalUnit) {
    await ecologicalUnitApi.create(ecologicalUnit)
  }

  /**
   *  Actualiza un grupo existente en la collection
   * @param {*} ecologicalUnit
   */
  async function update(ecologicalUnit) {
    await ecologicalUnitApi.update(ecologicalUnit)
  }

  /**
   * Verificar si una unidad ecologica puede ser eliminada
   * Devuelve true si no está asociada a ninguna unidad de manejo
   * @param {*} enterpriseId
   * @param {*} farmId
   * @param {*} ecologicalUnitId
   */
  async function canDeleteEcologicalUnit(enterpriseId, farmId, ecologicalUnitId) {
    try {
      const response = await ecologicalUnitApi.canDeleteEcologicalUnit(enterpriseId, farmId, ecologicalUnitId)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
  }

  /**
   * Verificar si un arreglo de unidades ecologicas pueden ser eliminadas
   * Devuelve true si ninguna está asociada a una unidad de manejo
   * @param {*} idsToDelete
   */
  async function canDeleteEcologicalUnits(idsToDelete) {
    try {
      const response = await ecologicalUnitApi.canDeleteEcologicalUnits(idsToDelete)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
  }


  return {
    findForSelector,
    findAll,
    getTotal,
    validateEcologicalUnitName,
    deleteOne,
    deleteMany,
    create,
    update,
    canDeleteEcologicalUnit,
    canDeleteEcologicalUnits
  }
})()
